<div #main
     [width]="width"
     [style.max-height.px]="maxHeight"
     [style.backgroundColor]="backgroundColor"
     class="comboBoundList"
     [style.box-shadow]="currencyCombo ? 'none' : ''"
     [style.border]="currencyCombo ? '1px solid #E2E8ED' : ''"
     [style.border-radius]="currencyCombo ? '4px' : ''"
     [ngClass]="{ comboBoundListCustomDates: showCustomDatesBtn }"
     (blur)="onBlur($event)"
     tabindex="-1"
     attr.data-testid="{{ testId }}-boundlist">
    <ul class="cursor-default">
        <ng-container *ngFor="let item of BoundListData; let i = index">
            <simple-btn *ngIf="i === 0 && isNewCompany"
                        [width]="180"
                        [backgroundFillCls]="'o2Background'"
                        [hoverFillCls]="'o1Background'"
                        [boxShadowCls]="'primary-shadow'"
                        [class]="'new-company-btn'"
                        [text]="'NEW_ORGANISATION' | translate"
                        i18n-text
                        [textCls]="'p2Font'"
                        [height]="30"
                        [cornerRadius]="50"
                        [horizontalPadding]="20"
                        data-testid="NewCompanyBtn"
                        (click)="addNewCompany()">
            </simple-btn>
            <li *ngIf="item.value.indexOf('divider') !== -1; else element" class="divider"></li>
            <ng-template #element>
                <li style="display: flex"
                    [ngClass]="{ 'li-custom-dates': showCustomDatesBtn, 'li-currency-combo' : currencyCombo }"
                    (click)="onSelectItem(item)"
                    data-testid="comboItem"
                    class="{{
            item != null && combo && item.id == combo.getValue()
              ? combo &&
                combo.selectedItemClass &&
                combo.selectedItemClass.length
                ? combo.selectedItemClass
                : 'selected-li'
              : ''
          }} {{ combo != null ? combo.inputTextClass : 'defTextCls' }} {{
            item.hasTopOutLine ? 'outline-top' : ''
          }} {{ item.hidden ? 'hidden' : '' }} {{
            combo ? (item.disabled ? combo.disabledItemClass : '') : ''
          }}">
                    <div *ngIf="(item.hidden == undefined || item.hidden != true) && item.imgCls"
                         style="margin-top: -2px; margin-right: 5px"
                         class="{{ item.imgCls }}"></div>
                    <div *ngIf="(item.hidden == undefined || item.hidden != true)
                            && item.value.indexOf('10% off') === -1
                            && item.value.indexOf('50+ chat to us') === -1"
                         data-testid="comboItemValue">
                        {{ item.value }}
                    </div>
                    <div *ngIf="item.value.indexOf('10% off') !== -1"
                         style="display: flex">
                        {{ getValue(item.value) }}&nbsp;&nbsp;&nbsp;
                        <div class="subscription-discount h5Font o2Color">
                            {{ getDiscount(item.value) }}
                        </div>
                    </div>
                    <div *ngIf="item.value.indexOf('50+ chat to us') !== -1">
                        <div class="chat-us h3Font mb2Color">{{ item.value }}</div>
                    </div>
                </li>
            </ng-template>

        </ng-container>
        <li class="btn-area cnt-column-centered li-custom-dates"
            *ngIf="showCustomDatesBtn"
            attr.data-testid="{{ testId }}-combobox-custom-dates-item">
            <simple-btn #customDatesButton
                        *ngIf="showCustomDatesBtn"
                        [width]="120"
                        [textCls]="'small-btn-text'"
                        [height]="30"
                        [cornerRadius]="50"
                        [horizontalPadding]="20"
                        [text]="customDatesText | translate"
                        [rightImgCls]="'custom-dates-arrow'"
                        [rightImgHoverCls]="'custom-dates-arrow-hover'"
                        [rightSpace]="5"
                        (click)="handleCustomDatesClick()"
                        attr.data-testid="{{ testId }}-customDatesButton"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'g4Background'"
                        [borderWidth]="2"
                        [borderColorCls]="'g4Border'"
                        [hoverBorderColorCls]="'g4Border'"
                        [textColorCls]="'g4Color'"
                        [hoverTextColorCls]="'white-color'">
            </simple-btn>
        </li>
    </ul>
</div>